import endpoints from '../endpoints' 

const oktaAuthConfig = {
  issuer: endpoints.OKTA_ISSUER,
  clientId: endpoints.EC_OKTA_CLIENT_ID,
  redirectUri: window.location.origin + '/login/callback',
  scopes: ['openid', 'profile', 'email'],
  pkce: true,

}

const oktaSignInConfig = {
  baseUrl: endpoints.OKTA_BASE_URL,
  issuer: endpoints.OKTA_ISSUER,
  clientId: endpoints.EC_OKTA_CLIENT_ID,
  redirectUri: window.location.origin + '/login/callback',
  scopes: ['openid', 'profile', 'email'],
  // Widget defaults to OIE + Interaction Code; use Classic unless your org enables Interaction Code on the AS.
  useClassicEngine: true,
  authParams: {
    issuer: endpoints.OKTA_ISSUER,
    pkce: true,
  },
  // Additional documentation on config options can be found at https://github.com/okta/okta-signin-widget#basic-config-options
}

export { oktaAuthConfig, oktaSignInConfig }